import axios from 'axios';

// API configuration
const config = {
  // In development, point directly to the backend server
  // In production, use the custom domain for API calls
  API_BASE_URL: process.env.NODE_ENV === 'production' 
    ? 'https://budgie.ducklab.net/api'
    : 'http://localhost:5000/api',
};

// Debug logging to help troubleshoot API issues
console.log('API Configuration:', {
  NODE_ENV: process.env.NODE_ENV,
  API_BASE_URL: config.API_BASE_URL,
  isProduction: process.env.NODE_ENV === 'production'
});

// Create an axios instance with default configuration
const api = axios.create({
  baseURL: config.API_BASE_URL,
  withCredentials: true,
});

// Add a request interceptor to add the auth token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    console.log('API Request:', {
      method: config.method,
      url: config.url,
      baseURL: config.baseURL,
      hasToken: !!token
    });
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to help debug errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      method: error.config?.method,
      data: error.response?.data
    });
    return Promise.reject(error);
  }
);

export { api };
export default config;
